<template>
  <div class="personage">
    <div class="personage_tit">
      个人信息
    </div>
    <div class="personage_items">
      <div class="personage_item">
        <div class="personage_name">
          姓名
        </div>
        <div class="personage_input">
          <input type="text"  v-model="information.name" @blur="inputname" class="personage_select" placeholder="请输入姓名（必填）">
        </div>
      </div>
      <div class="personage_item">
        <div class="personage_name">
          手机号
        </div>
        <div class="personage_input">
          <input type="text" maxlength="11" v-model="information.phone" @blur="inputphone" class="personage_select" placeholder="请填写手机号（必填）">
        </div>
      </div>
      <div class="personage_item">
        <div class="personage_name">
          性别
        </div>
        <div class="personage_input">
          <el-select v-model="information.sex" class="personage_select" placeholder="请选择" @change="sexChange">
            <el-option v-for="items in sexoption" :key="items.value" :label="items.label" :value="items.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="personage_item">
        <div class="personage_name">
          生日
        </div>
        <div class="personage_input">
          <el-date-picker class="personage_select" v-model="information.birthday" type="date" @change="dataChange"
            placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <div class="personage_item">
        <div class="personage_name">
          所在地区
        </div>
        <div class="personage_input">
          <el-cascader size="large" class="personage_select" :options="adressoptions" v-model="information.areaarr"
            @change="addressChange">
          </el-cascader>
        </div>
      </div>
      <div class="personage_btns">
         <div class="personage_btn" @click="personagefn">
           保存并使用
         </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    regionData,
    CodeToText,
    TextToCode
  } from 'element-china-area-data'
  import {getpersonageapi,setpersonageapi} from "../../../api/http.js"
  export default {
    name: "personage",
    data() {
      return {
        adressoptions: regionData,
        sexoption: [{
          value: '1',
          label: '女'
        }, {
          value: '0',
          label: '男'
        }],
        information:{
            address:"",//大地区
            name:"",//姓名
            phone:null,//电话号码
            birthday:null,
            gender:"",
            areaarr:"",
            avatarUrl:"",
            sex:""
        },
      }
    },
    created() {
    this._getinformation()
   // TextToCode[str.split("/")[0]][str.split("/")[1]][str.split("/")[2]].code
    },
    methods: {
     async _getinformation(){
        const res =await getpersonageapi()
        if(res.data.code == 200){
          console.log(res.data.data);
          if(res.data.data.address!=null){
           res.data.data.areaarr=TextToCode[res.data.data.address.split("/")[0]][res.data.data.address.split("/")[1]][res.data.data.address.split("/")[2]].code
          }
          res.data.data.gender==0?res.data.data.sex="男":res.data.data.sex='女'
          this.information= res.data.data
          this.$message("请求成功")
        }else{
         this.$message("请求失败")
        }
      },
      // 个人信息提交
     async personagefn(){
        var namereg = /^[\u4e00-\u9fa5]+$/
        var phonereg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/
        if(this.information.name=="" || !namereg.test(this.information.name)){
            return this.$message("请输入你的名字")
        }
       if(this.information.phone==null || !phonereg.test(this.information.phone) || this.information.phone==""){
           return this.$message("请输入你的手机号码")
       }
       if(this.information.birthday==null){
           return this.$message("请选择日期")
       }
       if(this.information.address==null){
           return this.$message("请选择你的省市")
       }
       console.log(this.information);
        const res =await setpersonageapi(this.information)
        console.log(res);
       if(res.data.code == 200){
         this.$router.push({
           path:"/home"
         })
         this.$message("提交成功")
       }else{
         this.$message(res.data.msg)
       }
      },
      // 地址
      addressChange(value) {
        this.information.address = CodeToText[value[0]] + '/' + CodeToText[value[1]] + '/' + CodeToText[value[2]]
      },
      // 性别
      sexChange() {
        this.information.gender = this.information.sex
      },
      // 电话号码
      inputphone(){
        var phonereg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])[0-9]{8}$/
        phonereg.test(this.information.phone) ? this.$message("手机号输入正确") : this.$message("请输入正确的手机号")
      },
      // 姓名
      inputname(){
        var namereg = /^[\u4e00-\u9fa5]+$/
        namereg.test(this.information.name) ? this.$message("姓名输入正确") : this.$message("输入正确的姓名")
      },
      // 生日
      dataChange() {
        let date = new Date(this.information.birthday)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        const time = y + '-' + m + '-' + d;
        this.information.birthday = time
      }
    }
  }
</script>

<style lang="less">
  .personage {
    width: 100%;
    font-size: 16px;

    .personage_tit {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #292929;
      margin-bottom: 20px;
    }

    .personage_items {
      width: 100%;
      height: 600px;
      border: 1px solid #CCCDCE;
      padding: 50px 230px 50px 40px;
      box-sizing: border-box;

      .personage_item {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 90px;
        border-bottom: 1px solid rgba(154, 154, 154, 0.31);

        .personage_name {
          width: 200px;
          text-align: center;
        }

        .personage_input {
          flex: 1;
          display: flex;
          .personage_select{
            width: 500px;
            border: none;
            outline: none;
            background-color: transparent;
          }

        }
      }
      .personage_btns{
        width: 100%;
        height: 90px;
        display:flex;
        justify-content: center;
        align-items: center;
        padding-top: 50px;
        .personage_btn{
          width: 136px;
          height: 40px;
          background: #FF4444;
          border-radius: 4px;
          font-weight: 400;
          font-size: 16px;
          line-height: 40px;
          color: #FFFFFF;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/view/personage.vue